
import React,{ useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import cyan from '@material-ui/core/colors/cyan';
import pink from '@material-ui/core/colors/pink';
import red from '@material-ui/core/colors/red';
// import ReactToPrint from 'react-to-print';
import './Label.css';

const useStyles = makeStyles((theme) => ({
  '@global':{
    body:{
      backgroundColor:"#e2dedf",
    }
  },
  title: {

  },
  subTitle:{
    fontWeight: "normal"
  },
  root: {
    backgroundColor:"#e2dedf",
    flexGrow: 1,
    padding: theme.spacing(2),

    textAlign: 'center',
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      // width: '40ch',
    },
    '&$required': {
      color: 'white'
    }
  },
  textField: {
    fontSize: 50, //works!

    '& p':{
      color: red[600],
    }
  },
      formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  menuButton: {
    marginLeft: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  button: {
    margin: theme.spacing(1)
  },
  paper: {
    backgroundColor:"#e2dedf",
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  busy: {
    textAlign: 'center',
    padding: theme.spacing(2),
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  }
}));
const theme = createMuiTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: pink[400],
    },
    secondary: {
      main: pink[200],
    },
    inherit: {
      main: cyan[200],
    },
  },
});

export default function Card() {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
    <div className={classes.root}>
    <img src='logo.png' height='40px'/>
<br/>        <h3>תודה שהצטרפת למועדון הלקוחות</h3>
    </div>

  </ThemeProvider>
  );
}
